import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import Locate from "leaflet.locatecontrol";

function LocateControl({ options, startDirectly }) {
  const map = useMap();

  useEffect(() => {
    const lc = new Locate(options);
    lc.addTo(map);

    if (startDirectly) {
      lc.start();
    }

    return () => {
      try { lc.remove(); } catch (_) {}
    };
  }, [map, options, startDirectly]);

  return null;
}

export default LocateControl;